/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BottomBar_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SiteNav_viewer" | "VipAccountManagerLink_viewer" | "TradeAccountManagerLink_viewer" | "SuspectedTradeUserLazy_viewer">;
    readonly " $refType": "BottomBar_viewer";
};
export type BottomBar_viewer$data = BottomBar_viewer;
export type BottomBar_viewer$key = {
    readonly " $data"?: BottomBar_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BottomBar_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BottomBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "VipAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLazy_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'cf5f968280aeb056e81a3764a220ccff';
export default node;
